import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCollections from '../reducers/collections.reducer';
import * as fromRoot from '../../../store';
import { getRouterState } from '../../../store';
import { getProductsFiltered } from '../reducers/products.reducer';

// tslint:disable-next-line:max-line-length
export const getCollectionState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.collections);

export const getCollectionEntities = createSelector(getCollectionState, fromCollections.getCollectionsEntities);

export const getAllCollections = createSelector(getCollectionEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]);
});
export const getCollectionsLoaded = createSelector(getCollectionState, fromCollections.getCollectionsLoaded);
export const getCollectionsLoading = createSelector(getCollectionState, fromCollections.getCollectionsLoading);
export const getCollectionError = createSelector(getCollectionState, fromCollections.getCollectionsError);

export const getSelectedCollection = createSelector(getAllCollections, fromRoot.getRouterState, (collections, router) => {
  return router.state && collections?.find(a => [a.handle, a.originalHandle].some(a => a === router.state.params['collectionHandle']));
});

export const getSelectedCollectionLoaded = createSelector(getSelectedCollection, collection => {
  return (collection && Object.keys(collection).indexOf('filters') >= 0) || false;
});
